import React, { useEffect, useState } from 'react';
import './Certificates.css';
import googleImg from '../../assets/images/Google Image.png';
import infosysImg from '../../assets/images/Infosys Springboard Image.png';
import guviImg from '../../assets/images/GUVI  Image.png';
import greatLearningImg from '../../assets/images/Great Learning Image.png';
import hackerRankImg from '../../assets/images/HackerRank Image.jpeg';
import roadmapImg from '../../assets/images/roadmap-logo.png';
import awsImg from '../../assets/images/AWS Image.webp';
import microsoftImg from '../../assets/images/microsoft image.webp';
import linkedinImg from '../../assets/images/linkedin.png';
import onlineWebinarImg from '../../assets/images/online webinar.png';

// Certificate data with metadata matching the reference design
const certificates = [
  {
    name: 'Google Certificates',
    provider: 'Google',
    subtitle: 'Cloud & Technology',
    icon: '🎓',
    btnTheme: 'btn-google',
    badgeTheme: 'badge-google',
    image: googleImg,
    link: '/Certificates/Certificatedetail/google-certificates',
  },
  {
    name: 'Infosys Springboard Certificates',
    provider: 'Infosys',
    subtitle: 'Learning Platform',
    icon: '💼',
    btnTheme: 'btn-infosys',
    badgeTheme: 'badge-infosys',
    image: infosysImg,
    link: '/Certificates/Certificatedetail/infosys-springboard-certificates',
  },
  {
    name: 'Guvi Certificate',
    provider: 'Guvi',
    subtitle: 'Online Learning',
    icon: '🌐',
    btnTheme: 'btn-guvi',
    badgeTheme: 'badge-guvi',
    image: guviImg,
    link: '/Certificates/Certificatedetail/guvi-certificates',
  },
  {
    name: 'Great Learning Certificates',
    provider: 'Great Learning',
    subtitle: 'Professional Learning',
    icon: '🎒',
    btnTheme: 'btn-greatlearning',
    badgeTheme: 'badge-greatlearning',
    image: greatLearningImg,
    link: '/Certificates/Certificatedetail/great-learning-certificates',
  },
  {
    name: 'Hacker Rank Certificates',
    provider: 'HackerRank',
    subtitle: 'Coding & Problem Solving',
    icon: '💻',
    btnTheme: 'btn-hackerrank',
    badgeTheme: 'badge-hackerrank',
    image: hackerRankImg,
    link: '/Certificates/Certificatedetail/hacker-rank-certificates',
  },
  {
    name: 'Udemy Certificate',
    provider: 'Udemy',
    subtitle: 'Online Learning',
    icon: '🌐',
    btnTheme: 'btn-udemy',
    badgeTheme: 'badge-udemy',
    image: require('../../assets/images/udemy.png'),
    link: '/Certificates/Certificatedetail/udemy-certificates',
  },
  {
    name: 'One Roadmap Certificate',
    provider: 'One Roadmap',
    subtitle: 'Career & Development',
    icon: '🚀',
    btnTheme: 'btn-roadmap',
    badgeTheme: 'badge-roadmap',
    image: roadmapImg,
    link: '/Certificates/Certificatedetail/one-roadmap-certificate',
  },
  {
    name: 'AWS Certificate',
    provider: 'AWS',
    subtitle: 'Cloud Computing',
    icon: '☁️',
    btnTheme: 'btn-aws',
    badgeTheme: 'badge-aws',
    image: awsImg,
    link: '/Certificates/Certificatedetail/aws-certificates',
  },
  {
    name: 'Microsoft Certificate',
    provider: 'Microsoft',
    subtitle: 'Technology & Development',
    icon: '🛡️',
    btnTheme: 'btn-microsoft',
    badgeTheme: 'badge-microsoft',
    image: microsoftImg,
    link: '/Certificates/Certificatedetail/microsoft-certificate',
  },
  {
    name: 'LinkedIn Certificate',
    provider: 'LinkedIn',
    subtitle: 'Professional Growth',
    icon: '👥',
    btnTheme: 'btn-linkedin',
    badgeTheme: 'badge-linkedin',
    image: linkedinImg,
    link: '/Certificates/Certificatedetail/linkedin-certificate',
  },
  {
    name: 'Online Webinar Certificate',
    provider: 'Webinar',
    subtitle: 'Tech Seminars & Workshops',
    icon: '🎓',
    btnTheme: 'btn-webinar',
    badgeTheme: 'badge-webinar',
    image: onlineWebinarImg,
    link: '/Certificates/Certificatedetail/onlinewebinar-certificate',
  },
];

// 3D Diploma / Certificate Hero Illustration
const CertificatesHeroIllustration = () => (
  <div className="hero-diploma-graphic" aria-hidden="true">
    <svg
      viewBox="0 0 540 360"
      className="hero-cert-svg"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Glow Filters */}
        <filter id="diploma-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="30" result="blur" />
        </filter>
        <filter id="cert-shadow" x="-20%" y="-20%" width="150%" height="150%">
          <feDropShadow dx="0" dy="16" stdDeviation="18" floodColor="#000000" floodOpacity="0.45" />
        </filter>
        <filter id="badge-shadow" x="-30%" y="-30%" width="160%" height="160%">
          <feDropShadow dx="0" dy="8" stdDeviation="10" floodColor="#000000" floodOpacity="0.35" />
        </filter>

        {/* Gradients */}
        <linearGradient id="diploma-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#f1f5f9" />
        </linearGradient>
        <linearGradient id="gold-seal-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#fde047" />
          <stop offset="50%" stopColor="#eab308" />
          <stop offset="100%" stopColor="#ca8a04" />
        </linearGradient>
        <linearGradient id="ribbon-red" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#f97316" />
          <stop offset="100%" stopColor="#dc2626" />
        </linearGradient>
        <linearGradient id="tile-blue-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#38bdf8" />
          <stop offset="100%" stopColor="#2563eb" />
        </linearGradient>
        <linearGradient id="tile-purple-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#c084fc" />
          <stop offset="100%" stopColor="#7c3aed" />
        </linearGradient>
      </defs>

      {/* Ambient Lighting Background */}
      <circle cx="340" cy="180" r="140" fill="#38bdf8" opacity="0.14" filter="url(#diploma-glow)" />
      <circle cx="200" cy="150" r="120" fill="#a855f7" opacity="0.13" filter="url(#diploma-glow)" />

      {/* Background Matrix & Orbital Elements */}
      <ellipse cx="280" cy="200" rx="210" ry="85" stroke="#38bdf8" strokeWidth="1" strokeDasharray="6 6" opacity="0.2" />

      {/* MAIN 3D CERTIFICATE DIPLOMA (Isometric Angle) */}
      <g transform="matrix(0.97 -0.06 0.04 0.98 20 20)" filter="url(#cert-shadow)">
        {/* Certificate Outer Border Glow */}
        <rect x="156" y="56" width="268" height="198" rx="16" fill="none" stroke="#38bdf8" strokeWidth="3" strokeOpacity="0.4" />
        
        {/* Certificate Card Base */}
        <rect x="160" y="60" width="260" height="190" rx="14" fill="url(#diploma-bg)" stroke="#cbd5e1" strokeWidth="1.5" />

        {/* Certificate Header Accent Bar */}
        <path d="M 160 74 Q 290 60 420 74 L 420 78 L 160 78 Z" fill="#2563eb" opacity="0.15" />
        <rect x="180" y="76" width="220" height="4" rx="2" fill="#3b82f6" opacity="0.4" />

        {/* CERTIFICATE Header Word */}
        <text
          x="290"
          y="108"
          fill="#1e293b"
          fontSize="15"
          fontWeight="800"
          letterSpacing="4"
          fontFamily="system-ui, sans-serif"
          textAnchor="middle"
        >
          CERTIFICATE
        </text>

        {/* Decorative Divider Under Word */}
        <rect x="235" y="116" width="110" height="2" rx="1" fill="#cbd5e1" />

        {/* Certificate Body Text Lines */}
        <rect x="200" y="132" width="180" height="4" rx="2" fill="#94a3b8" opacity="0.6" />
        <rect x="220" y="144" width="140" height="4" rx="2" fill="#94a3b8" opacity="0.4" />
        <rect x="195" y="156" width="190" height="4" rx="2" fill="#cbd5e1" opacity="0.5" />
        <rect x="210" y="168" width="160" height="4" rx="2" fill="#cbd5e1" opacity="0.4" />

        {/* Signature Line */}
        <rect x="190" y="200" width="70" height="2" rx="1" fill="#64748b" opacity="0.6" />
        <text x="225" y="214" fill="#94a3b8" fontSize="8" fontFamily="sans-serif" textAnchor="middle">VERIFIED</text>

        {/* GOLD MEDAL SEAL BADGE WITH RIBBONS */}
        <g transform="translate(345, 175)">
          {/* Ribbon Tails */}
          <polygon points="12,18 2,46 16,38 30,46 20,18" fill="url(#ribbon-red)" />
          {/* Circular Seal */}
          <circle cx="16" cy="16" r="22" fill="url(#gold-seal-grad)" stroke="#ffffff" strokeWidth="2" filter="url(#badge-shadow)" />
          {/* Inner Ring */}
          <circle cx="16" cy="16" r="17" fill="none" stroke="#fef08a" strokeWidth="1.5" strokeDasharray="3 2" />
          {/* Star Icon in Center */}
          <polygon
            points="16,8 18.5,13 24,14 20,18 21,24 16,21 11,24 12,18 8,14 13.5,13"
            fill="#ffffff"
          />
        </g>
      </g>

      {/* FLOATING 3D BADGES AROUND DIPLOMA */}
      {/* 1. Graduation Cap Tile (Top-Left) */}
      <g className="floating-cert-badge cert-float-1" filter="url(#badge-shadow)">
        <rect x="80" y="65" width="58" height="58" rx="16" fill="url(#tile-blue-grad)" />
        {/* Graduation Cap Icon */}
        <path d="M 109 82 L 89 92 L 109 102 L 129 92 Z" fill="#ffffff" />
        <polygon points="98,97 98,106 109,111 120,106 120,97 109,102" fill="#f8fafc" opacity="0.95" />
        <path d="M 125 93 L 125 106 L 123 108 L 127 108 L 125 106" stroke="#facc15" strokeWidth="2" />
      </g>

      {/* 2. Document Tile (Top-Right) */}
      <g className="floating-cert-badge cert-float-2" filter="url(#badge-shadow)">
        <rect x="420" y="95" width="56" height="56" rx="16" fill="url(#tile-blue-grad)" />
        {/* Document Icon */}
        <rect x="435" y="108" width="26" height="30" rx="3" fill="#ffffff" />
        <rect x="439" y="114" width="18" height="2.5" rx="1.2" fill="#3b82f6" />
        <rect x="439" y="119" width="14" height="2.5" rx="1.2" fill="#3b82f6" />
        <rect x="439" y="124" width="18" height="2.5" rx="1.2" fill="#3b82f6" />
        <rect x="439" y="129" width="10" height="2.5" rx="1.2" fill="#3b82f6" />
      </g>

      {/* 3. Rosette Medal Tile (Bottom-Left) */}
      <g className="floating-cert-badge cert-float-3" filter="url(#badge-shadow)">
        <circle cx="108" cy="225" r="28" fill="url(#tile-purple-grad)" />
        {/* Rosette Icon */}
        <circle cx="108" cy="222" r="14" fill="#ffffff" />
        <circle cx="108" cy="222" r="9" fill="#a855f7" />
        <polygon points="103,232 99,246 108,241 117,246 113,232" fill="#facc15" />
      </g>

      {/* Sparkles & Star Accents */}
      {/* Gold 4-Point Star */}
      <path
        d="M 395 55 Q 395 65 405 65 Q 395 65 395 75 Q 395 65 385 65 Q 395 65 395 55 Z"
        fill="#facc15"
      />
      {/* Purple Sparkle */}
      <path
        d="M 235 45 Q 235 53 243 53 Q 235 53 235 61 Q 235 53 227 53 Q 235 53 235 45 Z"
        fill="#c084fc"
      />
      {/* Pink Cross Sparkle */}
      <g transform="translate(145, 155)">
        <line x1="0" y1="-6" x2="0" y2="6" stroke="#ec4899" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="-6" y1="0" x2="6" y2="0" stroke="#ec4899" strokeWidth="2.5" strokeLinecap="round" />
      </g>
      {/* Cyan Plus */}
      <g transform="translate(435, 230)">
        <line x1="0" y1="-5" x2="0" y2="5" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" />
        <line x1="-5" y1="0" x2="5" y2="0" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" />
      </g>
    </svg>
  </div>
);

const Certificates = ({ isDarkMode }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`certificates-page ${isDarkMode ? 'dark' : ''}`}>
      {/* 1. HERO SECTION */}
      <section className="certificates-hero-section">
        <div className="hero-background-glows" aria-hidden="true">
          <div className="cert-orb orb-top-left"></div>
          <div className="cert-orb orb-center-purple"></div>
          <div className="cert-orb orb-right-cyan"></div>
        </div>

        <div className="certificates-hero-container">
          {/* Left Column: Heading, Subtitle, Badge */}
          <div className="certificates-hero-left">
            <div className="hero-pill-badge">
              <span className="hero-badge-icon">🏅</span>
              <span>Achievements</span>
            </div>

            <h1 className="certificates-hero-title">
              My <span className="certificates-gradient-text">Certifications</span>
            </h1>

            <p className="certificates-hero-subtitle">
              A collection of certifications that showcase my learning journey and technical skills across various platforms.
            </p>

            {/* Decorative Dot Matrix Grid */}
            <div className="hero-dots-matrix" aria-hidden="true">
              {[...Array(24)].map((_, i) => (
                <span key={i} className="dot-node" />
              ))}
            </div>
          </div>

          {/* Right Column: 3D Isometric Diploma Graphic */}
          <div className="certificates-hero-right">
            <CertificatesHeroIllustration />
          </div>
        </div>
      </section>

      {/* 2. MAIN GALLERY SECTION */}
      <main className="certificates-main-content">
        {loading ? (
          <div className="certificates-loader-container">
            <div className="certificates-loader-spinner"></div>
            <p className="certificates-loader-text">Loading certifications showcase...</p>
          </div>
        ) : (
          <div className="certificates-gallery-container">
            <div className="certificates-grid">
              {certificates.map((cert, index) => (
                <article className="certificate-card" key={index}>
                  {/* Top Header: Provider Badge */}
                  <div className="certificate-card-header">
                    <span className={`provider-pill-badge ${cert.badgeTheme}`}>
                      {cert.provider}
                    </span>
                  </div>

                  {/* Provider Logo Container */}
                  <div className="certificate-image-container">
                    <img
                      src={cert.image}
                      alt={cert.name}
                      className="certificate-image"
                      loading="lazy"
                    />
                  </div>

                  {/* Certificate Information */}
                  <div className="certificate-info">
                    <h3 className="certificate-card-title">{cert.name}</h3>
                    <p className="certificate-card-subtitle">
                      <span className="subtitle-icon">{cert.icon}</span>
                      <span>{cert.subtitle}</span>
                    </p>
                  </div>

                  {/* Action Button */}
                  <div className="certificate-action">
                    <a
                      href={cert.link}
                      className={`view-certificate-btn ${cert.btnTheme}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>→ View Certificate</span>
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default Certificates;
